// // import useNotification from "../common/Notification";
// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import {
//     TextField,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     CircularProgress,
//     IconButton,
//     Stepper,
//     Step,
//     StepLabel,
//     Paper,
//     Chip,
//     Avatar,
//     Divider,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useEffect, useState, useRef } from "react";
// import Cookies from "js-cookie";
// import axios from "axios";
// import CancelIcon from "@mui/icons-material/Cancel";
// // import CustomizedDrawer from "../Email/CustomizedDrawer";
// // import { useConfirmation } from "../../context/ConfirmationDialogProvider";

// const base_url = "http://api.virtualprachar.com/api/whatsapp/personal/group";
// const baseUrl =
//     "http://api.virtualprachar.com/api/whatsapp/personal/whatsapp_queue";

// const steps = ["Message", "Attachments", "Recipients"];

// const fetchTemplates = async (userId) => {
//     try {
//         const response = await axios.get(
//             "http://api.virtualprachar.com/api/templates",
//             {
//                 params: { userId, role: "PERSONAL" },
//             }
//         );
//         return response.data.data || [];
//     } catch (error) {
//         console.error("Error fetching templates:", error);
//         return [];
//     }
// };

// const MessageStep = ({
//     templates,
//     selectedTemplate,
//     onTemplateSelect,
//     customMessage,
//     onMessageChange,
// }) => {
//     return (
//         <Box sx={{ width: "100%", mb: 4 }}>
//             <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
//                 Select a template or write your message
//             </Typography>

//             {templates.length > 0 && (
//                 <Box
//                     sx={{
//                         display: "flex",
//                         gap: 1,
//                         overflowX: "auto",
//                         py: 1,
//                         mb: 3,
//                         "&::-webkit-scrollbar": { height: "6px" },
//                         "&::-webkit-scrollbar-thumb": {
//                             backgroundColor: "rgba(0,0,0,0.2)",
//                         },
//                     }}
//                 >
//                     {templates.map((template) => (
//                         <Chip
//                             key={template.id}
//                             label={template.title}
//                             onClick={() => onTemplateSelect(template)}
//                             variant={
//                                 selectedTemplate?.id === template.id
//                                     ? "filled"
//                                     : "outlined"
//                             }
//                             color={
//                                 selectedTemplate?.id === template.id
//                                     ? "primary"
//                                     : "default"
//                             }
//                             sx={{ cursor: "pointer", minWidth: "120px" }}
//                         />
//                     ))}
//                 </Box>
//             )}

//             <TextField
//                 fullWidth
//                 label="Custom Message"
//                 variant="outlined"
//                 size="small"
//                 value={customMessage}
//                 onChange={onMessageChange}
//                 multiline
//                 rows={6}
//                 sx={{ mb: 2 }}
//             />
//         </Box>
//     );
// };

// export default MessageStep;

import React from "react";
import { Box, Typography, TextField, Chip } from "@mui/material";

const MessageStep = ({
    templates,
    selectedTemplate,
    onTemplateSelect,
    customMessage,
    onMessageChange,
    hasError,
}) => {
    console.log("TEMPLATES:", templates)
    return (
        <Box sx={{ width: "100%", mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Select a template or write your message
            </Typography>

            {templates?.length > 0 && (
                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                        overflowX: "auto",
                        py: 1,
                        mb: 3,
                        "&::-webkit-scrollbar": { height: "6px" },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "rgba(0,0,0,0.2)",
                        },
                    }}
                >
                    {templates?.map((template) => (
                        // <Chip
                        //     key={template.id}
                        //     label={template.template_title}
                        //     onClick={() => onTemplateSelect(template)}
                        //     variant={
                        //         selectedTemplate?.id === template.id
                        //             ? "filled"
                        //             : "outlined"
                        //     }
                        //     color={
                        //         selectedTemplate?.id === template.id
                        //             ? "primary"
                        //             : "default"
                        //     }
                        //     sx={{ cursor: "pointer", minWidth: "120px" }}
                        // />
                        <Chip
  key={template.id}
  label={template.template_title || "Untitled"}
  onClick={() => onTemplateSelect(template)}
  variant={selectedTemplate?.id === template.id ? "filled" : "outlined"}
  color={selectedTemplate?.id === template.id ? "primary" : "default"}
  sx={{ cursor: "pointer", minWidth: "120px" }}
/>

                    ))}
                </Box>
            )}

            <TextField
                fullWidth
                label="Custom Message"
                variant="outlined"
                size="small"
                value={customMessage}
                onChange={onMessageChange}
                multiline
                rows={6}
                sx={{ mb: 2 }}
                error={hasError}
                helperText={
                    hasError
                        ? "Please enter a message or select a template"
                        : ""
                }
            />
        </Box>
    );
};

export default MessageStep;
